<script>
import { BSkeleton } from "bootstrap-vue";

export default {
  extends: BSkeleton
};
</script>